import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, DialogModule } from 'primeng/primeng';
import { TranslateModule } from '@ngx-translate/core';

import { NotifyService } from './notify.service';
import { NotifyContainerComponent } from './notify-container/notify-container.component';
import { AlertComponent } from './alert/alert.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { ToastComponent } from './toast/toast.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    DialogModule,
    TranslateModule
  ],
  declarations: [
    AlertComponent,
    NotifyContainerComponent,
    ConfirmComponent,
    ToastComponent
  ],
  entryComponents: [
    AlertComponent,
    ConfirmComponent,
    ToastComponent
  ],
  providers: [
    NotifyService
  ],
  exports: [
    NotifyContainerComponent
  ]
})
export class NotifyModule { }



// WEBPACK FOOTER //
// /dist/src/app/notify/notify.module.ts